const Notes = (props) => {
  const _width = props.width || 24;
  return (
    <svg
      id="icon-Notes"
      xmlns="http://www.w3.org/2000/svg"
      data-name="icon-Notes"
      viewBox="0  0 80 80"
      width={_width}
      fill="none"
      {...props}
    >
      <path
        d="M74.9075 35.235L71.5183 49.3425C68.6133 61.5262 62.8725 66.4537 52.0825 65.4412C50.3533 65.3062 48.4858 65.0025 46.48 64.53L40.67 63.18C26.2487 59.8387 21.7875 52.8862 25.1766 38.7787L28.5658 24.6375C29.2575 21.7687 30.0875 19.2712 31.125 17.2125C35.1712 9.04497 42.0533 6.85122 53.6041 9.51747L59.3796 10.8337C73.87 14.1412 78.2966 21.1275 74.9075 35.235Z"
        stroke="#292D32"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M52.0825 65.4411C49.9383 66.8586 47.2408 68.0399 43.9554 69.0861L38.4912 70.8412C24.7616 75.1612 17.5337 71.5499 13.0725 58.1511L8.64579 44.8199C4.21913 31.4212 7.88496 24.3337 21.6145 20.0137L27.0787 18.2587C28.4966 17.8199 29.8454 17.4487 31.125 17.2124C30.0875 19.2712 29.2575 21.7687 28.5658 24.6374L25.1766 38.7787C21.7875 52.8862 26.2487 59.8386 40.67 63.1799L46.48 64.5299C48.4858 65.0024 50.3533 65.3061 52.0825 65.4411Z"
        stroke="#292D32"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M43.7134 28.7886L60.4863 32.9398"
        stroke="#292D32"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M40.3242 41.8501L50.3534 44.3476"
        stroke="#292D32"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export default Notes;
